import { trackRetailerMarketingBuilderLandingPageSignupModalOpenClick } from "@faire/web-api--source/events/retailerMarketing/click/builderLandingPageSignupModalOpen";
import { trackSignupOpenFdProductSignUpModalClick } from "@faire/web-api--source/events/signup/click/openFdProductSignUpModal";
import { trackSignupOpenFdSignUpModalClick } from "@faire/web-api--source/events/signup/click/openFdSignUpModal";
import { trackSignupOpenProductSignUpModalClick } from "@faire/web-api--source/events/signup/click/openProductSignUpModal";
import { trackSignupOpenSignUpModalClick } from "@faire/web-api--source/events/signup/click/openSignUpModal";
import { route as productPageRoute } from "@faire/web-api--source/routes/product/productToken";
import { matchPath } from "react-router-dom";
export var trackFDSignupModal = function(pathname) {
    var _match_params;
    var match = matchPath(pathname, {
        path: productPageRoute
    });
    var productToken = match === null || match === void 0 ? void 0 : (_match_params = match.params) === null || _match_params === void 0 ? void 0 : _match_params.productToken;
    if (productToken) {
        trackSignupOpenFdProductSignUpModalClick(productToken);
    } else {
        trackSignupOpenFdSignUpModalClick();
    }
};
export var trackSignupModal = function(productToken, pathname) {
    trackRetailerMarketingBuilderLandingPageSignupModalOpenClick(pathname !== null && pathname !== void 0 ? pathname : "");
    if (productToken) {
        trackSignupOpenProductSignUpModalClick(productToken);
    } else {
        trackSignupOpenSignUpModalClick();
    }
};
